<template>
  <div class="pagination">
    <el-pagination
      :current-page.sync="form.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'BasePagination',
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },

  methods: {
    handleSizeChange(e) {
      this.$emit('handleSizeChange', e)
    },
    handleCurrentChange(e) {
      console.log(e)
      this.$emit('handleCurrentChange', e)
    }
  }
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>
